var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-slider__arrow outline",class:_vm.computeClassName},[_c('the-svg-icon',{attrs:{"name":"arrow","size-w":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }